<div class="topDiv" [style.background-color]="backgroundColorScreen">
    <div class="agGridOuterDiv"> 

  <!-- Author- Renuka chama
  04/02/2026
  For creation of  loadobjectmstr screen -->

        <div>
            <mat-toolbar class="agGridtoperDiv card" style="
                    background: rgb(228 227 230 / 41%);border-top: 1px solid #a9a9a9a8;
            border-right: 1px solid #a9a9a9a8;
            border-left: 1px solid #a9a9a9a8;">
    
                        <label i18n="@@spmsUserReg" class="textColour">Load Objects</label>
                        
                        <span class="example-spacer"></span>
                          <button
          class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
          [style.background-color]="buttonColor"
          [style.min-width.px]="60"
          style="font-size: 12px; padding:0; height: 32px;"
          id="102"
          title="Import Data"
          (click)="importData()">
          Import
          <em class="fas fa-download" style="font-size: 12px; padding: 0 5px;"></em>
        </button>

              <button class="popup gridColour btn btn-rounded-button z-depth-1
                                             waves-effect waves-light text-capitalize" [style.background-color]="buttonColor"
                [style.min-width.px]="60" style="font-size: 12px; padding: 0; height: 32px;" title="Export Data"
                (click)="exportData()" id="132" id="103">
                Export
                <em class="fas fa-upload" style="font-size: 12px; padding: 0 5px;" title="Export Data"></em>
              </button>
              
             
              <button  class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                                [style.background-color]="buttonColor"
                                title="Upload File" id="108"
                                (click)="excelFileUploadForObjects()">
                          Upload File
              <em style="padding: 0px 0px 0px 10px;" class="fas fa-upload" title="Upload File"></em>
              </button>
                    
                        <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" 
                        [style.background-color]="buttonColor" id="114" title="Add Record"
                        (click)="openSaveForm('Save')">
                    Add Record <em style="padding: 0px 0px 0px 10px;" class="fas fa-plus-circle" title="Add Record"></em>
                </button>
                
                        <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="buttonColor" title="Download" (click) = "onBtExport()">Download
                          <em style="padding: 0px 0px 0px 10px;" class="fas fa-download example-icon" title="Download"></em>
                  </button>
                  
                    <div class="insertPageNoDiv">
                        <mat-form-field appearance="outline">
                            <mat-label i18n="@@spmsUserRegpageno">Page No</mat-label>
                            <input matInput type="text" (input)="onSearchChange($event.target.value)">
                        </mat-form-field>
                    </div>
    
                    <div class="selectRecordsDiv" style="width:9.5%">
                        <mat-form-field appearance="outline" style="width:100%">
                            <mat-label i18n="@@spmsUserRegrecords" style="color:black">Records</mat-label>
                            <mat-select [(ngModel)]="pagesize" (ngModelChange)="onPageSizeChanged()">
                                <mat-option value="10" selected>10</mat-option>
                                <mat-option value="200">200</mat-option>
                                <mat-option value="300">300</mat-option>
                                <mat-option value="400">400</mat-option>
                            </mat-select>
    
                        </mat-form-field>
                    </div>
                    <div class="card pagination paginationFirstButton paginationFirstlastButton">
                        <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onBtFirst()"></em>
                    </div>
                    <div class="card pagination paginationButtons btn-rounded">
                        <ul>
                            <li class="paginationliicon"><em class="fas fa-angle-left waves-effect waves-light"
                                    (click)="onBtPrevious()"></em></li>
                            <li>{{currentpage}}/{{totalpages}}</li>
                            <li class="paginationliicon" style="padding:0;"><em
                                    class="fas fa-angle-right waves-effect waves-light" (click)="onBtNext()"></em></li>
                        </ul>
                    </div>
                    <div class="card pagination paginationLastButton paginationFirstlastButton">
                        <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onBtLast()"></em>
                    </div>
                  </mat-toolbar>
                </div>
                <ag-grid-angular class="ag-theme-balham table-width tablestyles square scroolbar-dusty-grass square thin"
                [columnDefs]="columnDefs"  [animateRows]="true"
                [pagination]="true" [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowHeight]="35"
                [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"
                [paginationPageSize]="paginationPageSize" [paginationNumberFormatter]="paginationNumberFormatter"
                [enableRangeSelection]="true" [debug]="true" [rowClassRules]="rowClassRules"
                (paginationChanged)="onPaginationChanged()" [components]="components"
                (gridReady)="onGridReady($event)"  [getRowStyle]="getRowStyle" [hidden]="!true">
            </ag-grid-angular>
        </div>
    </div>